export default "CEE Bâtiment Professionnel — Primes pour PME et artisans | Solution Éco France";
